import {doc} from '../docs.js';
import {lazy} from './lazy.js';
import {extractCode} from './extract.js';
import {float, utils, extract} from './utils.js';
import {gl} from './struct.js';

doc(
    "gl.eq",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_eq  = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `(${float(codes[0])} == ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.gt",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_gt = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `(${float(codes[0])} > ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.gte",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_gte = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `(${float(codes[0])} >= ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.lt",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_lt = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `(${float(codes[0])} < ${float(codes[1])})`;
    }, b);
};


doc(
    "gl.lte",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_lte = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `(${float(codes[0])} <= ${float(codes[1])})`;
    }, b);
};

doc(
    "gl.and",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 2
    });

const gl_and  = (object, b) => {
    object.needsHotReload = true;
    return lazy((a) => {
        let codes = extractCode(a,b);
        object.flash();
        return `(${float(codes[0])} && ${float(codes[1])})`;
    }, b);
};


doc(
    "gl.cond",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 3
    });

const gl_cond = (object, then, thenElse) => {
    object.needsHotReload = true;
    return lazy((condition) => {
        let codes = extractCode(condition, then, thenElse);
        object.flash();
        return `(
    ${float(codes[0])} ? 
        ${float(codes[1])} : 
        ${float(codes[2])})`;
    }, then, thenElse);
};

doc(
    "gl.pass",
    {
    },
    "Fuck",
    () => 1,
    {
        isHot: true,
        inlets: 3
    });

const gl_pass = (object, a, b) => {
    object.needsHotReload = true;
    return lazy((value) => {
        let codes = extractCode(value, a, b);
        object.flash();
        return `(${float(codes[1])} == ${float(codes[2])} ? ${float(codes[0])} : 0.0)`;
    }, a,b);
};

doc(
    "gl.switch",
    {
        "switchNumber": ""
    },
    "switches based on argument",
    () => 1,
    {
        inlets: (x) => x + 1
    }
);

const gl_switch = (object, ...args) => {
    return ([switchNumber]) => {
        let x = switchHelp(object, switchNumber, args.filter(x => x() !== null && x() !== undefined), 0);
        return x;
    };
};

doc(
    "gl.anyLTE",
    {
        "condition list": "",
        "list": "",
    },
    "Returns 1 if any of the elements in first inlet is below the 2nd",
    () => 1,
    {
        inlets: 2
    }
);

const gl_any_lte = (object, list) => {
    return ([conditionList]) => {
        if (!list() || !conditionList) {
            return;
        }
        let x = belowHelp(object, conditionList, list(), 0);
        return x;
    };
};

const belowHelp = (object, conditionList, list, depth=0) => {
    if (list.length === 0) {
        return 0;
    }

    let elseCond = belowHelp(object, conditionList.slice(1), list.slice(1), depth+1); // else
    let _depth = depth;
    let element = list[0];
    let conditionElement = conditionList[0];
    return gl_cond(object,
                   () => 1,
                   () => elseCond
                  )([gl_lt(object, () => conditionElement)([element])]); // condition
    
}

doc(
    "gl.listSwitch",
    {
        "list": "",
    },
    "Returns 1 if any of the elements in first inlet is below the 2nd",
    () => 1,
    {
        inlets: 2
    }
);
const gl_list_switch = (object, list) => {
    return ([switchNumber]) => {
        if (!list()) {
            return;
        }
        let x = switchHelp(object, switchNumber, list().map(x => () => x), 0);
        return x;
    };
};

const switchHelp = (object, switchNumber, args, depth=0) => {
    if (args.length === 1) {
        return args[0]();
    }

    let elseCond = switchHelp(object, switchNumber, args.slice(1), depth+1); // else
    let _depth = depth;
    return gl_cond(object,
                   args[0], // then
                   () => elseCond
                  )([gl_eq(object, () => _depth)([switchNumber])]); // condition
    
}



export const conditions = {
    'gl.switch': gl_switch,
    'gl.cond': gl_cond,
    'gl.gt': gl_gt,
    'gl.gte': gl_gte,
    'gl.lt': gl_lt,
    'gl.lte': gl_lte,
    'gl.and': gl_and,
    'gl.eq': gl_eq,
    'gl.pass': gl_pass,
    'gl.listSwitch': gl_list_switch,
    'gl.anyLTE': gl_any_lte
};
